import gql from 'graphql-tag'

export const CreateTrustedContactMutation = gql`
  mutation CreateTrustedContactMutation($input: CreateTrustedContactInput!) {
    createTrustedContact(input: $input) {
      worker {
        id
      }
    }
  }
`
